<template>
<b-row>
    <b-col class="OTdashboardLeftPanel">
    <div class="OTfacet-title">
                            Refine By
                        </div>
    <FacetsContainer :facetId="facetId" v-for="facetId in facetIds" :key="facetId" @selectedFacets="onSelectedFacets"></FacetsContainer>
    </b-col>
</b-row>
</template>

<script>
import FacetsContainer from './FacetContainer.vue';

export default {
    data() {
        return {
            selectedFacets: {}
        }
    },
    computed: {
        facetIds() {
            return this.$store.state.facets.facetIds;
        }
    },

    methods: {
        onSelectedFacets(selectedFacets) {


            if(selectedFacets.dimensions.length == 0){
                delete this.selectedFacets[selectedFacets.facetId];
            } else {
            
                this.selectedFacets[selectedFacets['facetId']] = selectedFacets['dimensions'];
            }
            var nodes = Object.keys(this.selectedFacets).map((facetId) => {
                        return {
                            'type': 'condition',
                            'field': facetId,
                            'in': this.selectedFacets[facetId]
                        }
                    });

            var facet= {};
            if(nodes.length < 1){
                facet = new Object({
                    type  : 'condition',
                    field : 'TF_ID',
                    in    : ['LHD_ID']
                });
            } else if(nodes.length == 1) {
                facet = nodes[0]
            } else {
                facet.type = 'and';
                facet.nodes = nodes
            }

            var cmdMsg = {
                
                'filter': {
                    'queryPointId': "activities",
                    'facet' : facet   
                }
            };

            Object.keys(this.$store.state.components.componentDataPoints).forEach((component) => {
                const $this = this;
                Object.keys(this.$store.state.components.componentDataPoints[component]).forEach((datum) => {
                    this.$store.state.components.componentDataPoints[component][datum] = 0
                })
            });

            Object.keys(this.$store.state.components.clusterTotals).forEach((clusterId) => {
                const $this = this;
                Object.keys(this.$store.state.components.clusterTotals[clusterId]).forEach((datum) => {
                    this.$store.state.components.clusterTotals[clusterId][datum] = 0
                })
            });

            this.$socket.sendObj(cmdMsg);
        }
    },

    components: {
        FacetsContainer
    }
}

</script>
